import React from 'react';
import { yellow } from '../../components/Color';
import { getWindowUrlParams } from '../../utils/url';
import DirtyFormProxyButton from '../../components/DirtyFormProxy/DirtyFormProxyButton';
import typeUtils from '../../utils/type';
import { useStickyHeaderLayoutContext } from '../../../DesktopScripts/reactSrc/modules/detailPage/components/StickyHeaderLayout';
import { useStyleContextState } from '../styleContext';
import { ThemeStyle } from '../../utils/const';
import { isMobileAny } from '../../utils/device';
import { statusIcons } from '../../components/GenericStatusLabel';
import { HourGlassCircle } from '../../components/Icons/HourGlassCircle';

const getEntityStateActions = (entityStateChangeActions, statuses) => {
	return entityStateChangeActions.map((action) => {
		const { metadata } = action;

		if (action.hasOwnProperty('hasAccess') && !action.hasAccess) {
			return null;
		}

		return {
			...action,
			id: metadata.entityStateId,
			icon: statuses[metadata.entityStateId].icon,
			svgIcon: statuses[metadata.entityStateId].svgIcon,
			label: metadata.title,
			isPrimary: metadata.isPrimary,
			postData: metadata.postData,
			dataTestId: `${metadata.transition}TooltipItem`,
		};
	});
};

const getEntityStateButtons = ({ statuses = {}, onEntityStateChange, entityStateActions, disabled = false }) => {
	return entityStateActions
		.filter((action) => !!action.hasAccess)
		.map((action) => {
			const { metadata } = action;
			const hasStatusParams = !typeUtils.isNullOrUndefined(statuses[metadata.entityStateId]);
			const handleButtonClick = () => {
				onEntityStateChange(action);
			};

			return (
				<DirtyFormProxyButton
					link
					textAlign='left'
					hideConfirmButton
					dataTestId={`${metadata.transition}Button`}
					onClick={handleButtonClick}
					key={metadata.entityStateId}
					startIcon={
						hasStatusParams ? (
							statuses[metadata.entityStateId].svgIcon
						) : (
							<HourGlassCircle fill={yellow[7]} />
						)
					}
					disabled={disabled}
					dataFunction={`transaction-${metadata.entityStateId}`}
				>
					{metadata.title}
				</DirtyFormProxyButton>
			);
		});
};

const getEntityStateActionsAccesses = (actions) => {
	return actions.reduce((acc, item) => {
		return {
			...acc,
			[item.type]: { ...item },
		};
	}, {});
};

const getListDataUrlParam = () => {
	const { listData } = getWindowUrlParams();

	return listData;
};

export { getEntityStateActions, getEntityStateButtons, getEntityStateActionsAccesses, getListDataUrlParam };

export const useHeaderNavigationButtonsIsDarkTheme = () => {
	const isStickyHeader = useStickyHeaderLayoutContext();
	const styleContextTheme = useStyleContextState().theme;

	if (isMobileAny || isStickyHeader) {
		return false;
	}

	return styleContextTheme === ThemeStyle.Dark;
};

export const getEntityStateChangeActionButtonsList = ({
	onEntityStateChange,
	entityStateChangeActions,
	disabled = false,
}) => {
	return [...entityStateChangeActions].map((action) => {
		const { metadata } = action;
		const icon = statusIcons[metadata.statusIconId] || {};

		const handleButtonClick = () => {
			onEntityStateChange(action);
		};

		return (
			<DirtyFormProxyButton
				link
				textAlign='left'
				hideConfirmButton
				dataTestId={`${metadata.transition}Button`}
				onClick={handleButtonClick}
				key={metadata.entityStateId || metadata.transition}
				startIcon={icon}
				disabled={disabled}
				dataFunction={`transaction-${metadata.entityStateId}`}
			>
				{metadata.title}
			</DirtyFormProxyButton>
		);
	});
};
